// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__ojvzw","content":"LoadingAlert_content__3a3-w"};